import React from "react";
import classnames from "classnames";
// import logo from 'assets/tomo_logo_white.svg';
// import logo from 'assets/logo_white.svg';
import logo from "assets/logo_halloween_dark.svg";

const Logo = ({ white, style, className }) => (
  <div className={classnames("flex pt-4 pb-8 px-4", className)} style={style}>
    <img src={logo} alt="logo" />
  </div>
);

Logo.defaultProps = {
  white: false,
  className: "",
  style: {}
};

export default Logo;
